import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/prathamesh/Downloads/claude-transfer/locobuzz-website/app/ai-stack/responsegenie/ResponseGenieClient.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/prathamesh/Downloads/claude-transfer/locobuzz-website/components/BookDemoSection.js");
